import React from "react";
// import PDFPrinter from "./PDFPrinter";
import { Button, Icon } from "antd";
import PropTypes from "prop-types";

const ControlPanel = (props) => {
    const { pageNumber, numPages, setPageNumber, scale, setScale, rotateAngle, setRotate } = props;

    const isFirstPage = pageNumber === 1;
    const isLastPage = pageNumber === numPages;

    // const firstPageClass = isFirstPage ? "disabled" : "clickable";
    // const lastPageClass = isLastPage ? "disabled" : "clickable";

    // const goToFirstPage = () => {
    //     if (!isFirstPage) setPageNumber(1);
    // };
    const goToPreviousPage = () => {
        if (!isFirstPage) setPageNumber(pageNumber - 1);
    };
    const goToNextPage = () => {
        if (!isLastPage) setPageNumber(pageNumber + 1);
    };
    // const goToLastPage = () => {
    //     if (!isLastPage) setPageNumber(numPages);
    // };

    const onPageChange = (e) => {
        const { value } = e.target;
        setPageNumber(Number(value));
    };

    const isMinZoom = scale < 0.6;
    const isMaxZoom = scale >= 2.0;

    // const zoomOutClass = isMinZoom ? "disabled" : "clickable";
    // const zoomInClass = isMaxZoom ? "disabled" : "clickable";

    const zoomOut = () => {
        if (!isMinZoom) setScale(scale - 0.1);
    };

    const zoomIn = () => {
        if (!isMaxZoom) setScale(scale + 0.1);
    };

    const rotateLeft = () => {
        setRotate(rotateAngle - 90);
    };

    const rotateRight = () => {
        setRotate(rotateAngle + 90);
    };

    return (
        <div className="control-panel m-3 p-3 d-flex align-items-baseline justify-content-between" style={{width: "100%", paddingTop: "20px"}}>
            <div className="d-flex justify-content-between align-items-baseline" style={{width: "40%"}}>
                {/* <i
          className={`fas fa-search-minus mx-3 ${zoomOutClass}`}
          onClick={zoomOut}
        /> */}
                <Icon style={{paddingTop: "4px", paddingRight: "20px", paddingLeft: "20px"}} type="zoom-out" onClick={zoomOut} />
                <span>{(scale * 100).toFixed()}%</span>
                <Icon style={{paddingTop: "4px",  paddingLeft: "20px"}} type="zoom-in" onClick={zoomIn} />
                {/* <p onClick={zoomIn}>zoomIn</p> */}
            </div>
            <div className="d-flex justify-content-between align-items-baseline" style={{width: "30%"}}>
                {/* <i
          className={`fas fa-fast-backward mx-3 ${firstPageClass}`}
          onClick={goToFirstPage}
        />
        <i
          className={`fas fa-backward mx-3 ${firstPageClass}`}
          onClick={goToPreviousPage}
        /> */}
                <Icon style={{paddingTop: "6px", paddingRight: "20px"}} type="arrow-left" onClick={goToPreviousPage} />
                <span>
          Page{" "}
                    <input
                        name="pageNumber"
                        type="number"
                        min={1}
                        max={numPages || 1}
                        className="p-0 pl-1 mx-2"
                        value={pageNumber}
                        onChange={onPageChange}
                    />{" "}
          of {numPages}
                </span>
                <Icon style={{paddingTop: "6px",  paddingLeft: "20px"}} type="arrow-right" disabled={props.isDisabled} onClick={goToNextPage} />
                {/* <i
          className={`fas fa-forward mx-3 ${lastPageClass}`}
          onClick={goToNextPage}
        />
        <i
          className={`fas fa-fast-forward mx-3 ${lastPageClass}`}
          onClick={goToLastPage}
        /> */}
            </div>
            <div style={{width: "30%", textAlign: "right", display: "inline-flex"}}>
                <div className="mx-3">
                    <Button onClick={rotateLeft} style={{padding: "5px", fontSize: "12px", marginRight: "5px"}}>Rotate left</Button>
                </div>
                <div className="mx-3">
                    <Button onClick={rotateRight} style={{padding: "5px", fontSize: "12px"}}>Rotate Right</Button>
                </div>
            </div>
        </div>
    );
};

ControlPanel.propTypes = {
    pageNumber: PropTypes.any,
    numPages: PropTypes.any,
    setPageNumber: PropTypes.any,
    scale: PropTypes.any,
    setScale: PropTypes.any,
    rotateAngle: PropTypes.any,
    setRotate: PropTypes.any,
    isDisabled: PropTypes.any,
};


export default ControlPanel;
